<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row class="pb-1">
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.paymentContracts') }}</v-card-title
								>
							</v-col>
							<v-col class="d-flex justify-end pa-0 pl-2">
								<v-btn color="primary" @click="openModal">
									<v-icon small>fas fa-lock</v-icon>&nbsp;&nbsp;{{ $t('buttons.bulkLock') }}
								</v-btn>
							</v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="paymentContractsTable.additionalFilters"
									:default-sort="paymentContractsTable.defaultSort"
									:excel="true"
									:fields="paymentContractsTable.headers"
									:header-selection-key="'payment-contracts-headers'"
									:height="paymentContractsTable.height"
									:total-records="paymentContractsTable.total"
									:filter-save-key="'payment-contracts-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in paymentContractsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="paymentContractsTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="
												paymentContractsTable.selectedHeaders.includes(
													'payment_contract_type_id'
												)
											"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.payment_contract_type.name }}</b>
										</td>
										<td
											v-if="paymentContractsTable.selectedHeaders.includes('partner_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.partner_id == null ? '-' : item.partner.name }}</b>
										</td>
										<td
											v-if="paymentContractsTable.selectedHeaders.includes('candidate_id')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.candidate_id == null ? '-' : item.candidate.full_name }}</b>
										</td>
										<td
											v-if="paymentContractsTable.selectedHeaders.includes('date')"
											@click="editClick(item.id, false)"
										>
											{{ item.date != null ? item.date.split('-').reverse().join('.') : '' }}
										</td>
										<td
											style="text-align: right"
											v-if="paymentContractsTable.selectedHeaders.includes('total_bruto')"
											@click="editClick(item.id, false)"
										>
											<b>
												{{
													item.total_bruto != null
														? Number.isInteger(item.total_bruto)
															? item.total_bruto.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(item.total_bruto.toString())
															? item.total_bruto.toLocaleString('hr') + '0'
															: item.total_bruto.toLocaleString('hr')
														: ''
												}}
											</b>
										</td>
										<td
											style="text-align: right"
											v-if="paymentContractsTable.selectedHeaders.includes('payed')"
											@click="editClick(item.id, false)"
										>
											<b>
												{{
													item.payed != null
														? Number.isInteger(item.payed)
															? item.payed.toLocaleString('hr') + ',00'
															: /^\d+\.\d{1}$/.test(item.payed.toString())
															? item.payed.toLocaleString('hr') + '0'
															: item.payed.toLocaleString('hr')
														: ''
												}}
											</b>
										</td>
										<td
											style="text-align: right"
											v-if="paymentContractsTable.selectedHeaders.includes('debt')"
											@click="editClick(item.id, false)"
										>
											{{
												item.debt != null
													? Number.isInteger(item.debt)
														? item.debt.toLocaleString('hr') + ',00'
														: /^\d+\.\d{1}$/.test(item.debt.toString())
														? item.debt.toLocaleString('hr') + '0'
														: item.debt.toLocaleString('hr')
													: ''
											}}
										</td>
										<td
											v-if="
												paymentContractsTable.selectedHeaders.includes(
													'payment_contract_status_id'
												)
											"
											@click="editClick(item.id, false)"
										>
											{{ item.payment_contract_status.name }}
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<Modal :show-modal="showModal">
			<BulkLocking @close="closeModal" @reload="reloadData(paymentContractsTable.lastRequest)"></BulkLocking>
		</Modal>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';
import Modal from '../../trinkets/Modal';
import BulkLocking from './BulkLocking';

export default {
	name: 'PaymentContracts',
	components: { TheTable, Modal, BulkLocking },
	data: function () {
		return {
			paymentContractsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.id'), value: 'id', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.type'),
						value: 'payment_contract_type_id',
						type: 'dropdown|payment-contract-types',
						allowFilter: true,
					},
					{
						text: this.$t('fields.partner'),
						value: 'partner_id',
						type: 'dropdown|partners',
						allowFilter: true,
					},
					{
						text: this.$t('fields.candidate'),
						value: 'candidate_id',
						type: 'dropdown|candidates',
						allowFilter: true,
					},
					{ text: this.$t('fields.date'), value: 'date', type: '', allowFilter: true },
					{
						text: this.$t('fields.amountBruto'),
						value: 'total_bruto',
						type: '',
						allowFilter: true,
						alignRight: true,
					},
					{ text: this.$t('fields.payed'), value: 'payed', type: '', allowFilter: true, alignRight: true },
					{ text: this.$t('fields.left'), value: 'debt', type: '', allowFilter: true, alignRight: true },
					{
						text: this.$t('fields.status'),
						value: 'payment_contract_status_id',
						type: 'dropdown|payment-contract-statuses',
						allowFilter: true,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [
					{ text: this.$t('fields.date'), value: 'date', type: 'date_range' },
					{ text: this.$t('fields.amountBruto'), value: 'total_bruto', type: 'price_range' },
					{ text: this.$t('fields.payed'), value: 'payed', type: 'price_range' },
					{ text: this.$t('fields.left'), value: 'debt', type: 'price_range' },
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'id',
					descending: true,
				},
			},
			showModal: false,
		};
	},
	methods: {
		addClick() {
			this.$router.push('/payment-contracts/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/payment-contracts/' + id);
			} else {
				let routeData = this.$router.resolve('/payment-contracts/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.paymentContractsTable.selectedHeaders = headers;
		},
		openModal() {
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		reloadData(request) {
			this.paymentContractsTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'payment-contracts',
				request,
				(data, success) => {
					if (success) {
						vm.paymentContractsTable.items = data.items;
						vm.paymentContractsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.paymentContractsTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'payment-contracts',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/payment-contracts', data.items, (data, _) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.paymentContractsTable.height = window.innerHeight - 243 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}

		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.paymentContracts'), href: '/#/payment-contracts', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
